<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <CRow>
        <CCol sm="12">
          <div v-if="loading" class="text-center m-5">
            <div
              class="spinner-grow text-primary m-auto"
              style="width: 3rem; height: 3rem"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-else>

            <!-- <CCardGroup class="mb-4" deck>
              <CardClient
                elemento="cliente"
                title="algo"
                :loading="loading"
                :client="payment.client"
              />

              <CardParking
                v-if="hasProduct"
                elemento="Parking"
                :loading="loading"
                :parking="paymentProduct.parking"
                :showPlan="false"
                :plan="paymentProduct.plan"
              />

              <CardPaymenProduct
                v-if="hasProduct"
                elemento="Plan"
                title="algo"
                :loading="loading"
                :product="paymentProduct"
                :payment="payment"
                :paymentStatus="payment.status"
              />
            </CCardGroup> -->

            <CTabs
              :active-tab.sync="activeTab"
              add-tab-classes="container-tabs"
            >
              <CTab active>
                <template slot="title">
                  <CIcon name="cil-credit-card" height="22" />
                  Información del {{ elemento.toLowerCase() }}
                  <span v-if="paymentToEdit"
                    ><strong># {{ paymentToEdit.id }}</strong></span
                  >
                </template>

                <CCard>
                  <CCardHeader class="card-detail-header">
                    <slot name="header">
                      <span
                        v-if="paymentToEdit"
                        class="card-detail-header-title"
                      >
                        <CIcon name="cil-credit-card" />
                        Detalle del pago
                        <span v-if="isExtraPayment" class="text-black-50">
                          - {{ stringUtils.getProductLabel(paymentToEdit.products[0].product_type) }} </span>
                      </span>
                    </slot>

                    <div class="card-header-actions">
                      Referencia del pago:
                      <CBadge color="warning" class="p-2 ml-auto">
                        <span
                          v-if="paymentToEdit.reference"
                        >
                          {{ paymentToEdit.reference }}
                        </span>
                        <span v-else>
                          ---
                        </span>
                      </CBadge>
                    </div>
                  </CCardHeader>

                  <CCardBody>
                    <CListGroup>

                      <CListGroupItem
                        v-if="isExtraPayment"
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Concepto</strong>
                       <span v-if="paymentProduct.custom_text">{{ paymentProduct.custom_text }}</span>
                      </CListGroupItem>

                      <CListGroupItem
                        v-if="isExtraPayment"
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Método de pago</strong>
                       <span v-if="paymentProduct.payment_type">{{ getPaymentType(paymentProduct.payment_type) }}</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                        <strong>Fecha de creación</strong>
                        <span>{{
                          formatDateTimeCustom(payment.created_at)
                        }}</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                        <strong>Estado</strong>
                        <BadgePaymentStatus
                          :attribute="payment.status"
                        ></BadgePaymentStatus>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                        <strong>Referencia</strong>
                        <span v-if="payment.reference">{{ payment.reference }}</span>
                        <span v-else>---</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                        <strong>Tarjeta de crédito</strong>
                        <span v-if="payment.credit_card">{{ getCardLast4(payment.credit_card) }}</span
                        >
                        <span v-else>Sin datos</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                        <strong>Importe</strong>
                        <span>{{ totalPreDiscount }} €</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                        <strong>Descuento</strong>
                        <span v-if="totalDiscount">
                          {{ totalDiscount | toFixedNoRounding }} €
                        </span>
                        <span v-else>Sin descuento</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                        <strong>Total</strong>
                        <span> {{ payment.amount }} € </span>
                      </CListGroupItem>
                    </CListGroup>
                  </CCardBody>


                  <CCardFooter>

                  <!-- <div  class="d-flex justify-content-between align-items-center">
                  <span @click="deleteInvoice" style="cursor: pointer;"
                    :class="{
                      'text-secondary': !paymentToEdit.invoices_id && paymentToEdit.status === PAYMENT_PAID.key,
                      'text-danger': existenDatosCliente() && paymentToEdit.invoices_id
                    }"><CIcon name="cil-reload" /> Solicitar eliminar factura</span> -->

                  <div class="d-flex justify-content-end align-items-center" style="min-width: 200px">


                    <CBadge v-if="!existenDatosCliente()"
                      color="danger" class="button-invoice"> <CIcon name="cil-notes" height="22" /> Sin Datos para generar factura</CBadge>

                    <CBadge v-if="existenDatosCliente() && !paymentToEdit.invoices_id && paymentToEdit.status === PAYMENT_PAID.key" @click="generateInvoice(paymentToEdit)"
                      color="warning" class="button-invoice" style="cursor: pointer;"> <CIcon name="cil-notes" height="22" /> Generar factura</CBadge>

                    <CBadge v-if="existenDatosCliente() && paymentToEdit.invoices_id" @click="updateInvoice(paymentToEdit.invoice)"
                      color="warning" class="button-invoice mr-4" style="cursor: pointer;"> <CIcon name="cil-notes" height="22" /> Actualizar factura </CBadge>

                    <CBadge v-if="existenDatosCliente() && paymentToEdit.invoices_id" @click="downloadInvoice(paymentToEdit.invoice)"
                      color="success" class="button-invoice" style="cursor: pointer;"> <CIcon name="cil-notes" height="22" /> Descargar factura </CBadge>


                  </div>

                  <!-- </div> -->


                    <!-- <CButton type="submit" size="sm" color="success" style="float:right;" @click="editRegularClient">
                      <CIcon name="cil-check-circle"/> Confirmar edición
                  </CButton> -->

                    <!-- <div
                      class="d-flex justify-content-start align-items-center"
                      style="cursor: pointer; color: red"
                    >
                      <span v-if="!isCancelled" @click="modelDelete = true">
                        <CIcon name="cil-reload" />
                        Solicitar cancelación {{ elemento.toLowerCase() }}
                      </span>
                    </div> -->
                  </CCardFooter>

                </CCard>

              </CTab>

              <CTab v-if="hasProduct && !isExtraPayment">
                <template slot="title">
                  <span v-if="paymentToEdit && paymentProduct.product_type">
                   <CIcon :name="stringUtils.getIconProduct(paymentProduct.product_type)" height="22" /> </span>
                  Producto contratado
                  <span v-if="paymentToEdit && paymentProduct.product_type !== BASE.key"><strong># {{ paymentProduct.id }}</strong></span>
                </template>


                <CCard v-if="payment.products.length > 1">
                  <CCardBody>

                    <p>Detalle de los productos que componen el pago de un estacionamiento</p>
                    <!-- <p>Ir al estacionamiento</p> -->

                  </CCardBody>
                </CCard>

              <!-- <hr> -->


              <CardPaymentProductDetail
                v-for="(product, index) in payment.products" :key="index"
                elemento="Plan"
                title="algo"
                :loading="loading"
                :product="product"
                :payment="payment"
                :paymentStatus="payment.status"
              />


              </CTab>

              <!-- <CTab>
                <template slot="title">
                  <CIcon name="cil-notes" height="22" />
                  Factura
                  <span v-if="paymentToEdit"><strong># {{ paymentToEdit.invoices_id }}</strong></span>
                </template>

                <UpdateClientModal
                  v-bind:show="showModal"
                  :client="payment.client"
                  title="Actualizar Datos Factura"
                  element="Datos Factura"
                  @cancelled="showModal = $event"
                  @dataUpdated="updateDataClientInvoice"
                />

                <p v-if="!payment.client.billing_name">
                    Para generar la factura es necesario completar los datos de facturación
                </p>

                <BillingDetailsCard
                v-else
                :client="payment.client"
                @updateClient="showModal = $event"
                />

              </CTab> -->

              <!-- <CTab>
                <template slot="title">
                  <CIcon name="cil-reload" height="22" />
                  Devoluciones
                  <CBadge
                    color="success"
                    class="ml-auto"
                    v-if="paymentToEdit && items"
                    >{{ items.length }}</CBadge
                  >
                </template>

                <RefoundsList
                  v-bind:refounds="items"
                  elemento="Devoluciones"
                  :title="'Listado de Devoluciones'"
                  :loading="loadingRefound"
                  @cambiarPagina="cambiarPagina"
                  :rows="rows"
                  :pagina_actual="pagina_actual"
                  :perPage="perPage"
                  :total_paginas="total_paginas"
                />
              </CTab> -->
            </CTabs>

            <template v-if="paymentToEdit.status === PAYMENT_PAID.key">
              <BillingData2
                v-bind:client="client"
                :loading="loadingBilling"
                @updateClient="updateClientDataInvoice"
                v-on:toggle-company="client.billing_identification_type = $event ? 'empresa': 'particular' "
                v-on:toggle-billing-data="setClientBilling($event)"
              />
            </template>



          </div>
        </CCol>
      </CRow>
    </transition>

    <toast ref="toast"></toast>
  </div>
</template>

<script>
import { fetchOnePayment, generateInvoice, deleteInvoice, updateInvoice } from '@/app/shared/global/services/payment-service';
import { getInvoice } from "@/app/shared/global/services";
import { updateBillingData } from '@/app/shared/global/services/client-service';
import { fetchOneClient } from '@/app/views/clientes/shared/services';

import {
  fetchAllProductsActive, fetchAllProductsFinished, fetchAllProductsNotActive
} from '@/app/shared/global/services/product-service';

import stringUtils from "@/app/shared/utils/stringUtils";
import { formatDateTimeCustom , formatDateCustom, getCardLast4 } from '@/app/shared/utils/utils';
import { BASE, PAYMENT_PAID } from '@/config';

import BadgePaymentStatus from "@/components/badges/BadgePaymentStatus";
import CardPaymentProductDetail from "@/components/cards/CardPaymentProductDetail";
import BillingData2 from "@/app/views/clientes/shared/components/BillingData2";

// import CardClient from "@/components/cards/CardClient";
// import CardPaymenProduct from "@/components/cards/CardPaymenProduct";
// import CardParking from "@/components/cards/CardParking";
// import RefoundsList from "@/components/listados/RefoundsList";
// import UpdateClientModal from "@/app/views/clientes/shared/components/modals/UpdateClientModal";
// import BillingDetailsCard from "@/app/views/clientes/shared/components/BillingDetailsCard"
// import { fetchAllRefounds } from '../../devoluciones/shared/services';

export default {
  name: "DetallePago",
  components: {
    // UpdateClientModal,
    // BillingDetailsCard,
    // CardClient,
    // CardPaymenProduct,
    // CardParking,
    // RefoundsList,
    BadgePaymentStatus,
    CardPaymentProductDetail,
    BillingData2
  },
  data() {
    return {
      elemento: "Pago",
      payment: null,
      paymentProduct: null,
      paymentToEdit: null,
      paymentId: null,
      loading: true,
      loadingBilling: true,
      message: null,

      activeTab: 0,
      stringUtils: stringUtils,
      hasProduct: false,

      showModal: false,
      formatDateTimeCustom: formatDateTimeCustom,
      formatDateCustom: formatDateCustom,
      getCardLast4: getCardLast4,

      // Devoluciones relacionadas
      // items: [],
      // loadingRefound: false,
      // pagina_actual: 1,
      // rows: 0,
      // total_paginas: 1,
      // currentPage: this.pagina_actual,
      // perPage: 25,

      BASE: BASE,
      PAYMENT_PAID:PAYMENT_PAID,
      client: {},
      clientToEdit: null,
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.expired) {
      this.$refs.toast.showToast("La sesión ha caducado. Por favor, inicie sesión de nuevo.",null,"error","5000");
    }
  },
  created() {
    if (this.$route.params.id) {
      this.paymentId = this.$route.params.id;

      this.getPayment(this.$route.params.id);
      this.getClientLogged();
      // this.getRefounds();
      // this.getData();

    } else {
      this.$refs.toast.showToast("Url incorrecta.", null, "error", "2000");
      this.$router.push({ path: `/gestion/pagos` });
    }
  },
  computed: {
    isCancelled() {
      return this.payment.status === "CANCELLED";
    },
    isExtraPayment() {
      return this.payment?.products[0]?.product_type === 'extra' ? true : false;
    },
    isCustomPayment() {
      return this.payment?.products[0]?.product_type === 'custom' ? true : false;
    },
    totalDiscount() {
      return this.payment.products.reduce((total, actual) => total + actual.discount_amount, 0);
    },
    totalPreDiscount(){
      return this.payment.products.reduce((total, actual) => total + actual.amount, 0);
    }
  },
  methods: {

    getPaymentType( value ) {
      return value === 'CLIENT-TPV' ? 'Envío por email solicitud de pago' :
      value === 'AUTO' ? 'Pago automático tarjeta del cliente' : ''
    },

    getTypeProduct(item) {

      // Payment product_type = base, prepago, custom, extra
      // Productos product_type = perminutes, prepago, custom, extra

      // TODO: actualizar el api y en frontales a perminutes, unificar prefijo (base/perminutes)
      const productType = item.product_type === 'base' ? `perminutes` : item.product_type;

      return `${item.id}?data=${productType}`;
    },

    goToDetail() {
      this.$router.push(`/gestion/contrataciones/${this.getTypeProduct(this.paymentProduct)}`);
    },
    async getPayment(paymentId) {

      try {
        let resp = await fetchOnePayment(paymentId);

        if (resp.status !== "success") {
          this.$refs.toast.showToast(`Se ha producido un error al cargar`,null,"error","5000");
          this.loading = false;
          return;
        }

        this.paymentToEdit = resp.data;
        this.payment = { ...this.paymentToEdit };

        this.hasProduct =
          this.payment.products && this.payment.products[0] ? true : false;

        this.paymentProduct = { ...this.payment.products[0] };

        // product_type: "prepago" / "AUTO" - "CLIENT-TPV" /

        this.loading = false;
      } catch (e) {
        this.$refs.toast.showToast(
          `Se ha producido un error al cargar`,
          null,
          "error",
          "5000"
        );
        this.loading = false;
      }
    },

    updateDataClientInvoice() {
      this.getPayment(this.paymentId);
    },

    getIconProduct(payment) {
      if (payment.products[0]) {
        return payment.products[0].product_type === "custom"
          ? "cil-asterisk-circle"
          : payment.products[0].product_type === "prepago"
          ? "cil-chart-pie"
          : payment.products[0].product_type === "base"
          ? "cil-clock"
          : "cil-av-timer";
      } else {
        return "cil-av-timer";
      }
    },

    async deleteInvoice() {

      const errorMessage = 'Error en la eliminación de la factura.';

      if (!this.paymentToEdit.invoices_id && this.paymentToEdit.status !== PAYMENT_PAID.key) {
         this.$refs.toast.showToast(`No hay factura generada`, null, "warn", "2000");
        return
      }

      try {

        const resp = await deleteInvoice(this.payment.invoices_id);

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(  `${errorMessage} ${resp.data.message} `, null, "error", "5000");
          return
        }

        this.updateDataClientInvoice();
        this.$refs.toast.showToast(`Factura elimianada correctamente`, null, "success", "5000");

      }catch(e) {
          this.$refs.toast.showToast(`${errorMessage}`, null, "error", "5000");
      }

    },

    existenDatosCliente(){
      return this.payment?.client ? this.payment?.client.has_billing_info : false;
    },

    async generateInvoice(){

      try {

        const invoice = await generateInvoice(this.payment.id);

        if(!invoice) {
          return
        }

        this.updateDataClientInvoice();

        this.downloadInvoice(invoice.data);

      }catch(e) {
        this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
      }
    },

    async updateInvoice(invoice){

      try {
        const invoice = await updateInvoice(this.payment.id);

        if(!invoice) {
          this.$refs.toast.showToast(`Error en al actualizar los datos`, null, 'error', '2000');
          return
        }

        this.downloadInvoice(invoice.data);
      }catch(e) {
        this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
      }

    },

    async downloadInvoice(invoice){

      try {
        const response = await getInvoice(invoice).catch(e => {
          resetResponseType();
          this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
        });

        if (response) {
          this.downloadInvoicePdf(response, invoice);
        }
      }catch(e) {
        this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
      }

    },

    downloadInvoicePdf(response, invoice) {
      const file = new Blob([response.data], { type: 'application/pdf' });

      const fileURL = URL.createObjectURL(file);
      // const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

      // Open in browser
      // window.location.href = fileURL;
      const link = document.createElement('a');
      link.href = fileURL;

      // link.download = invoice.reference + '';
      // link.click();

      link.setAttribute('download', invoice.reference + '' );
      document.body.appendChild(link);
      link.click();

      this.$refs.toast.showToast('Factura descargada con éxito', null, 'success', '2000');

      document.body.removeChild(link);

      // setTimeout(() => {
      //   // For Firefox it is necessary to delay revoking the ObjectURL
      //   // document.removeChild(link);
      //   window.URL.revokeObjectURL(fileURL);
      // }, 100);
    },

    updateClientDataInvoice(value) {
      this.updateBillingData(value);
    },

    updateBillingData(billingData) {
      const errorMessage = `Error al actualizar los datos de facturación`;
      this.loadingBilling = true;

      updateBillingData(billingData)
        .then((resp) => {

          if (resp?.status !== "success") {
            this.$refs.toast.showToast(errorMessage, null, "error","5000")
            return;
          }

          this.updateDataClientInvoice();

          this.$refs.toast.showToast(`Actualizados correctamente`, null, "success","5000");

        })
        .catch((err) => {
          // console.log(err);
          this.$refs.toast.showToast(`${errorMessage} - ${err?.status}`, null, "error","5000");
        })
        .finally(() => {
          this.loadingBilling = false;
          this.getClientLogged();
        });
    },

    setClientBilling(value) {
      this.client.billing_name = value ?
        this.clientToEdit.name + " " + this.clientToEdit.surnames
        : this.clientToEdit.billing_name;
    },

    async getClientLogged() {

      try {

        this.loadingBilling = true;
        let resp = await fetchOneClient(localStorage.getItem('user_id'));

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(  `Se ha producido un error al cargar ${resp.data.message} `, null, "error", "5000");
          this.loadingBilling = false;
          return
        }

        this.clientToEdit = resp.data;

        this.client = { ...this.clientToEdit };
        this.client.company = this.client.billing_identification_type === 'empresa' ? true : false;

        this.loadingBilling = false;

      } catch(e) {
        console.log(e);
        this.loadingBilling = false;

        this.$refs.toast.showToast( 'Se ha producido un error al cargar el user', null, "error", "5000");
      }
    },

  },
};
</script>

<style lang="scss" scoped>
</style>
